import { Injectable } from '@angular/core';
import {MesApiService} from "common-shared";
import {map} from "rxjs/operators";
import {plainToInstance} from "class-transformer";

export class DraftToFinal {
  Key: string;
  DraftId: string;
  FinalId: string;
  Connections: DraftToFinal[];
  DraftModifiedBy: string;
  FinalModifiedBy: string;
}

@Injectable({
  providedIn: 'root'
})
export class DraftService extends MesApiService {

  constructor() {
    super('Draft');
  }

  getDrafts(modifiedBy: string, search: string) {
    return this.getList<DraftToFinal>({
      action: 'GetByItemGroups'
    }, {modifiedBy: modifiedBy, search: search}).pipe(map(value => {
      return plainToInstance(DraftToFinal, value.data);
    }));
  }

  getDraftResources(modifiedBy: string, search: string) {
    return this.getList<DraftToFinal>({
      action: 'GetDraftResources'
    }, {modifiedBy: modifiedBy, search: search}).pipe(map(value => {
      return plainToInstance(DraftToFinal, value.data);
    }));
  }

  publishByGroups(selectedGroups: DraftToFinal[]) {
    return this.add(selectedGroups ?? [],{
      action: 'PublishByGroups'
    }).pipe(map(value => {
      return value.data;
    }));
  }

  publishByResources(selectedResources: DraftToFinal[]) {
    return this.add(selectedResources ?? [],{
      action: 'PublishByResources'
    }).pipe(map(value => {
      return value.data;
    }));
  }
}
